import { render, staticRenderFns } from "./live-finish.vue?vue&type=template&id=6cd1d8e2&lang=pug"
import script from "./live-finish.vue?vue&type=script&lang=coffee"
export * from "./live-finish.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports